import React from 'react';
import Banner from 'shared/banner';
import {
  faCircleInfo,
  faCircleCheck
} from '@fortawesome/pro-solid-svg-icons';

const extraVariants = {
  vgCollectInfo: {
    className: 'banner--vg-collect-info',
    icon: faCircleInfo,
  },
  vgVerification: {
    className: 'banner--vg-verification',
    icon: faCircleCheck,
  },
  vgWaitlist: {
    className: 'banner--vg-waitlist',
    icon: faCircleInfo,
  },
  vgSignCa: {
    className: 'banner--vg-sign-ca',
    icon: faCircleInfo,
  }
};

import './styles.scss';

export const LeadBanner = (props) => {
  return <Banner {...props} extraVariants={extraVariants} />;
};
